// TODO: update file when new icon's are added or find a way to retrieve from CMS
export const IconUIType = {
    none: '',
    accident: 'accident',
    add_children: 'add-children',
    add_coverage: 'add-coverage',
    add_document: 'add-document',
    all_insurances: 'all-insurances',
    annual_reward: 'annual-reward',
    archive: 'archive',
    arrow_diagonal_down_left: 'arrow-diagonal-down-left',
    arrow_diagonal_down_right: 'arrow-diagonal-down-right',
    arrow_diagonal_up_left: 'arrow-diagonal-up-left',
    arrow_diagonal_up_right: 'arrow-diagonal-up-right',
    arrow_down: 'arrow-down',
    arrow_down_left: 'arrow-down-left',
    arrow_down_right: 'arrow-down-right',
    arrow_left: 'arrow-left',
    arrow_left_down: 'arrow-left-down',
    arrow_left_up: 'arrow-left-up',
    arrow_right: 'arrow-right',
    arrow_right_down: 'arrow-right-down',
    arrow_right_up: 'arrow-right-up',
    arrow_turn_down_left: 'arrow-turn-down-left',
    arrow_turn_down_right: 'arrow-turn-down-right',
    arrow_turn_left_down: 'arrow-turn-left-down',
    arrow_turn_left_up: 'arrow-turn-left-up',
    arrow_turn_right_down: 'arrow-turn-right-down',
    arrow_turn_right_up: 'arrow-turn-right-up',
    arrow_turn_up_left: 'arrow-turn-up-left',
    arrow_turn_up_right: 'arrow-turn-up-right',
    arrow_up: 'arrow-up',
    arrow_up_left: 'arrow-up-left',
    arrow_up_right: 'arrow-up-right',
    bicycle: 'bicycle',
    building: 'building',
    burglary_prevention: 'burglary-prevention',
    cancel_insurance: 'cancel-insurance',
    car: 'car',
    caravan: 'caravan',
    car_theft: 'car-theft',
    cat: 'cat',
    chat: 'chat',
    checkmark_fill: 'checkmark-fill',
    checkmark_stroke: 'checkmark-stroke',
    chevron_filled_down: 'chevron-filled-down',
    chevron_filled_left: 'chevron-filled-left',
    chevron_filled_right: 'chevron-filled-right',
    chevron_filled_up: 'chevron-up',
    chevron_down: 'chevron-down',
    chevron_left: 'chevron-left',
    chevron_right: 'chevron-right',
    chevron_up: 'chevron-up',
    close_grey: 'close-grey',
    close_thin: 'close-thin',
    claim_free_years: 'claim-free-years',
    close: 'close',
    continue: 'continue',
    deceased: 'deceased',
    devices: 'devices',
    dog: 'dog',
    download_green_card: 'download-green-card',
    edit_insurance: 'edit-insurance',
    edit_login: 'edit-login',
    edit_pay: 'edit-pay',
    edit_personal_data: 'edit-personal-data',
    electric_car: 'electric-car',
    emergency: 'emergency',
    extra_occupant: 'extra-occupant',
    eu_stars: 'eu-stars',
    facebook: 'facebook',
    fair: 'fair',
    family_composition: 'family-composition',
    faq: 'faq',
    fire_prevention: 'fire-prevention',
    folder: 'folder',
    form: 'form',
    globe: 'globe',
    heartbroken: 'heartbroken',
    house: 'house',
    house_arrow: 'house-arrow',
    inboedel: 'inboedel',
    information: 'information',
    instagram: 'instagram',
    insurance: 'insurance',
    legal: 'legal',
    liability: 'liability',
    logged_in_state: 'logged-in-state',
    login: 'login',
    mail: 'mail',
    mailing_address: 'mailing-address',
    marriage: 'marriage',
    menu: 'menu',
    moped: 'moped',
    most_chosen: 'most-chosen',
    motorcycle: 'motorcycle',
    payment_details: 'payment-details',
    personal_data: 'personal-data',
    pet: 'pet',
    phone: 'phone',
    picture: 'picture',
    privacy: 'privacy',
    profile_picture: 'profile-picture',
    recover_data: 'recover-data',
    remove_insurance: 'remove-insurance',
    replace_car: 'replace-car',
    replace_motorcycle: 'replace-motorcycle',
    report_damage: 'report-damage',
    road: 'road',
    safety: 'safety',
    scooter: 'scooter',
    search: 'search',
    star_fill: 'star-fill',
    star_stroke: 'star-stroke',
    swipe: 'swipe',
    tools: 'tools',
    travel: 'travel',
    updates: 'updates',
    view_damage: 'view-damage',
    view_document: 'view-document',
    view_invoice: 'view-invoice',
    x: 'x'
};

type ValueOf<T> = T[keyof T];

export type ValueOfIconUIType = ValueOf<typeof IconUIType>;

export const iconOptions = Object.keys(IconUIType).map((key) => IconUIType[key as keyof typeof IconUIType]);
export const dropDownIconOptions = iconOptions.reduce((acc, curr) => ({ ...acc, [curr]: curr }), {});
